import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AdminLayout } from "../AdminPages";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;
const Stat = ({ label, value, id }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid={`lg-total-${id}`}>
    <p className="text-xs uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-1 text-2xl font-semibold text-slate-900">{value}</p>
  </div>
);

// Admin only: each member's voice library, how often lines are reused, and the voice cost that saves.
export default function AdminLibraryGrowth() {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/api/admin/library-growth`, auth()).then((r) => setD(r.data)).catch(() => toast.error("Couldn't load library growth")); }, []);
  const t = d?.totals;
  return (
    <AdminLayout title="Library Growth" subtitle="Every line voiced in a member's voice is kept and reused. Admin only: members never see costs.">
      {t && (
        <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-5">
          <Stat id="members" label="Members" value={t.members} />
          <Stat id="lines" label="Lines in libraries" value={t.lines} />
          <Stat id="reuses" label="Times reused" value={t.reuses} />
          <Stat id="reuse-pct" label="Reuse rate" value={`${t.reuse_pct}%`} />
          <Stat id="saved" label="Voice cost saved" value={gbp(t.saved_gbp)} />
        </div>
      )}
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="lg-table">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-wider text-slate-500"><tr className="border-b border-slate-200">
            <th className="px-3 py-2 text-left">Member</th><th className="px-3 py-2 text-right">Lines</th><th className="px-3 py-2 text-right">Reused</th>
            <th className="px-3 py-2 text-right">Reuse rate</th><th className="px-3 py-2 text-right">Spent voicing</th><th className="px-3 py-2 text-right">Saved</th>
          </tr></thead>
          <tbody>{(d?.items || []).map((r) => (
            <tr key={r.user_id} className="border-b border-slate-100" data-testid={`lg-row-${r.user_id}`}>
              <td className="px-3 py-2">{r.name || "Unknown"} <span className="text-xs text-slate-400">{r.email}</span></td>
              <td className="px-3 py-2 text-right tabular-nums">{r.lines}</td><td className="px-3 py-2 text-right tabular-nums">{r.reuses}</td>
              <td className="px-3 py-2 text-right tabular-nums">{r.reuse_pct}%</td><td className="px-3 py-2 text-right tabular-nums">{gbp(r.spent_gbp)}</td>
              <td className="px-3 py-2 text-right tabular-nums text-emerald-700">{gbp(r.saved_gbp)}</td>
            </tr>
          ))}</tbody>
        </table>
        {d && !d.items.length && <p className="p-4 text-sm text-slate-500">No saved voice lines yet.</p>}
      </div>
      {d && <p className="mt-3 text-xs text-slate-500">Reuse counting started in November 2026. Cost uses £{d.cost_per_char_gbp} per character.</p>}
    </AdminLayout>
  );
}
